import { useState } from "react";
import Select from "react-select";
import { MultipleSelectBoxProps, MultipleSelectBoxModel } from "./multiple-selectbox";

const MultipleSelectBox = (props: MultipleSelectBoxProps) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const selectAllLabel = '*';

    const selectAllOption = { value: -1, label: selectAllLabel };
    const defaultValue = props.selected ? props.selected : [];
    const options = props.nonSelected ? props.nonSelected : [];

    const initialVisibleOptions: MultipleSelectBoxModel[] = options.length === defaultValue?.length ? options : [selectAllOption, ...options ];
  
    const removeSelectAllOption = (defaultOptionList: MultipleSelectBoxModel[]): MultipleSelectBoxModel [] => {
      //let avaliableOptions = defaultOptionList.filter(defaultOption => !selectedOptionList.some(selectedOption => defaultOption.value === selectedOption.value));
      return defaultOptionList.filter((avalableOption: MultipleSelectBoxModel) => { return avalableOption.label !== selectAllLabel; });
    };

    const [availableOptions, setAvailableOptions] = useState<MultipleSelectBoxModel[]>(
      initialVisibleOptions,
    );

    const [selectedValues, setSelectedValues] = useState<MultipleSelectBoxModel[]>(
        defaultValue,
    );

    const relayOnChange = (newSelectedOptions:  MultipleSelectBoxModel[]) => {
        const selectAllIsSelected = !!newSelectedOptions.find(
            o => o.value === selectAllOption.value,
        );

        const newComponentState = selectAllIsSelected ? {
            selectedValues: options,
            availableOptions: [],
        }
        : {
            selectedValues: newSelectedOptions,
            availableOptions: initialVisibleOptions  
        };

        setSelectedValues(newComponentState.selectedValues);
        setAvailableOptions(newComponentState.availableOptions);
        props.onChange(newComponentState.selectedValues, removeSelectAllOption(initialVisibleOptions))
    };
    
    return (
        <Select
            defaultValue={selectedOption}
            onChange={relayOnChange}
            options={availableOptions}
            value={selectedValues}
            isMulti={true}
            isSearchable={true}
            menuIsOpen={true}
        />
    )
}

export function mapToMultipleSelectBoxModal(items: { id: number, value: string }[] | []): MultipleSelectBoxModel[] {
    let tmpSelectedItems: MultipleSelectBoxModel[] = [];

    if (!items) { return tmpSelectedItems }

    items.map(item => {
        tmpSelectedItems = [...tmpSelectedItems, {value: item.id, label: item.value}]
    })
    
    return tmpSelectedItems;
}



export default MultipleSelectBox